import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import dataTableReducer from './slices/dataTable/dataTableSlice';
import keycloackConfigReducer from './slices/keycloackConfig/keyCloakConfigSlice';
import tenantIdReducer from './slices/tenantId/tenantIdSlice';
import tiersReducer from './slices/tiers/tiersSlice';
import tokenReducer from './slices/token/tokenSlice';
import visibilityReducer from './slices/visibility/visibilitySlice';
import { baseApi } from '../services/baseApi';

// Create the root reducer separately so we can extract the RootState type
export const rootReducer = combineReducers({
  dataTable: dataTableReducer,
  token: tokenReducer,
  tenantId: tenantIdReducer,
  tiers: tiersReducer,
  keycloackConfig: keycloackConfigReducer,
  visibility: visibilityReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

// Store for app
export const _setupStore = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
});

// Store for tests
export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(baseApi.middleware),
    preloadedState,
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];

setupListeners(_setupStore.dispatch);
